import React from "react";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import Icon from "@ant-design/icons";
import { Badge, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { getDirection } from "../../../../helpers";
import { ReactComponent as NotificationCircle } from "../../../../assets/icons/chatStatuses/green-notification-circle.svg";
import styles from "./ClickableIcon.module.scss";
const ClickableIcon = ({ component: Component, action, status, tooltipTransKey, notification, badgeCount, to, }) => {
    const { t } = useTranslation();
    const onClick = (event) => {
        if (to && (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey))
            return;
        action === null || action === void 0 ? void 0 : action();
    };
    const controlProps = {
        className: classnames(styles.button, {
            [styles.buttonColorSelect]: status,
        }),
        onClick,
        "aria-label": tooltipTransKey ? t(tooltipTransKey) : undefined,
    };
    const content = (React.createElement(React.Fragment, null,
        React.createElement(Icon, { className: styles.buttonSmooth, component: Component }),
        notification && React.createElement(Icon, { className: styles.notificationIcon, component: NotificationCircle })));
    const control = to ? (React.createElement(NavLink, Object.assign({ to: to, exact: to === "/", isActive: status === undefined ? undefined : () => status, activeClassName: styles.buttonColorSelect }, controlProps), content)) : (React.createElement("button", Object.assign({ type: "button", "aria-pressed": status }, controlProps), content));
    return (React.createElement(Tooltip, { placement: getDirection() === "rtl" ? "left" : "right", title: tooltipTransKey ? t(tooltipTransKey) : undefined }, badgeCount === undefined ? (control) : (React.createElement(Badge, { count: badgeCount, className: styles.badge }, control))));
};
export default ClickableIcon;
